import { publicGet } from "@/shared/http/public-http";
import type { AppSettingDto, SettingType } from "./app-settings.dto";

/**
 * GET /setting/app — configurações do app resolvidas por hierarquia:
 * o setting da loja (storeId) vence o padrão (storeId null).
 *
 * Leitura pública ANÔNIMA (ver `public-http.ts`). Na prática quem chama é o
 * `loadBootstrap`, que resolve a loja ANTES para passá-la como argumento — ler
 * cookie dentro de escopo cacheado é proibido.
 */
export async function getAppSettings(storeId = 0): Promise<AppSettingDto[]> {
    return publicGet<AppSettingDto[]>("/setting/app", {
        params: { storeId },
        tags: [`settings:${storeId}`],
    });
}

/** Extrai o content de um setting pelo tipo, já tipado pelo chamador. */
export function pickSetting<TContent>(
    settings: AppSettingDto[],
    type: SettingType
): TContent | null {
    const setting = settings.find((s) => s.settingType === type);
    return (setting?.content as TContent) ?? null;
}
